/* AKZERN YAPI — /en UI translation supplement.
   Translates theme-hardcoded Turkish UI strings that Shopify content
   translation and site.js's dictionary don't cover. Runs ONLY on the
   English storefront. Full text-node exact matching => no partial corruption. */
(function(){
  var loc = (window.SHOP_LOCALE || document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (loc.slice(0,2) !== 'en') return;

  var MAP = {
    "Ana Sayfa":"Home",
    "Kategoriler":"Categories",
    "Ürünler":"Products",
    "Öne çıkanlar":"Featured",
    "Fiyat: Artan":"Price: Low to High",
    "Fiyat: Azalan":"Price: High to Low",
    "En Yeni":"Newest",
    "Çok Satan":"Best Selling",
    "İNDİRİM":"SALE",
    "Stokta":"In Stock",
    "Tükendi":"Sold Out",
    "Bu kategoride ürün bulunamadı.":"No products found in this category.",
    "Orijinal & faturalı ürün":"Original & invoiced product",
    "● Stokta, hemen kargolanır":"● In stock, ships immediately",
    "● Tükendi":"● Sold out",
    "Sepete Ekle":"Add to Cart",
    "🚚 Hızlı Kargo":"🚚 Fast Shipping",
    "↩️ Kolay İade":"↩️ Easy Returns",
    "🛡️ Güvenli Ödeme":"🛡️ Secure Payment",
    "1.500₺ üzeri ücretsiz, Türkiye geneli":"Free over ₺1,500, across Türkiye",
    "14 gün içinde koşulsuz iade":"Unconditional returns within 14 days",
    "3D Secure · orijinal & faturalı":"3D Secure · original & invoiced",
    "Ürün Bilgileri":"Product Details",
    "Açıklama":"Description",
    "Marka":"Brand",
    "Kategori":"Category",
    "Stok Kodu":"SKU",
    "Durum":"Status",
    "Sepet":"Cart",
    "Teslimat":"Delivery",
    "Ödeme":"Payment",
    "Sepetiniz henüz boş":"Your cart is empty",
    "Kategorilere göz atın, doğru donanımı bulun.":"Browse categories and find the right hardware.",
    "Alışverişe Başla":"Start Shopping",
    "🎉 Tebrikler! Ücretsiz kargo kazandınız.":"🎉 Congratulations! You have earned free shipping.",
    "Sipariş Özeti":"Order Summary",
    "Ara Toplam":"Subtotal",
    "İndirim":"Discount",
    "Kargo":"Shipping",
    "Ücretsiz":"Free",
    "Ödemede hesaplanır":"Calculated at checkout",
    "Toplam":"Total",
    "KDV dahildir":"VAT included",
    "Uygula":"Apply",
    "Ödemeye Geç →":"Checkout →",
    "Ödemeye Geç":"Checkout",
    "🔒 3D Secure ile güvenli ödeme":"🔒 Secure payment with 3D Secure",
    "Kaldır":"Remove",
    "← Alışverişe devam et":"← Continue shopping",
    "Arama":"Search",
    "Görseldeki + işaretlerine gelin — her parça gerçek ürünümüz":"Hover the + markers — every piece is a real product of ours"
  };

  var ATTR = {
    "Kulp, kilit, menteşe, vida veya marka ara…":"Search handles, locks, hinges, screws or brands…",
    "E-posta adresiniz":"Your email address",
    "Kupon kodu":"Coupon code",
    "Sipariş notu (opsiyonel)":"Order note (optional)",
    "E-posta":"Email",
    "Ara...":"Search..."
  };

  var RE = [
    [/^(\d[\d.,]*)\s+ürün$/,     "$1 products"],
    [/^\((\d[\d.,]*)\s+ürün\)$/, "($1 products)"],
    [/^%\s*(\d+)\s+indirim$/,    "$1% off"]
  ];

  function convert(text){
    if (text == null) return null;
    var key = text.trim();
    if (!key) return null;
    if (Object.prototype.hasOwnProperty.call(MAP, key)) return text.replace(key, MAP[key]);
    for (var i=0;i<RE.length;i++){ if (RE[i][0].test(key)) return text.replace(RE[i][0], RE[i][1]); }
    return null;
  }

  function walkNode(nd){ var r=convert(nd.nodeValue); if (r!=null && r!==nd.nodeValue) nd.nodeValue=r; }

  function walk(root){
    if (!root) return;
    try {
      if (root.nodeType === 3){ walkNode(root); return; }
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list=[];
      while ((n = w.nextNode())) list.push(n);
      list.forEach(walkNode);
    } catch(e){}
  }

  function attrs(root){
    try{
      var els = root.querySelectorAll ? root.querySelectorAll('[placeholder],[aria-label],[title]') : [];
      Array.prototype.forEach.call(els, function(el){
        ['placeholder','aria-label','title'].forEach(function(a){
          var v = el.getAttribute && el.getAttribute(a);
          if (v && ATTR[v.trim()]) el.setAttribute(a, ATTR[v.trim()]);
        });
      });
    }catch(e){}
  }

  function run(){ walk(document.body); attrs(document); }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  try{
    var mo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        if (!m.addedNodes) return;
        Array.prototype.forEach.call(m.addedNodes, function(nd){
          if (nd.nodeType === 1){ walk(nd); attrs(nd); }
          else if (nd.nodeType === 3){ walkNode(nd); }
        });
      });
    });
    mo.observe(document.documentElement, {childList:true, subtree:true});
    setTimeout(function(){ try{ mo.disconnect(); }catch(e){} }, 8000);
  }catch(e){}
})();
